import {FC, useState, useEffect, useRef} from 'react'
import {PageTitle} from '../../../../_metronic/layout/core'
import {Card, Row, Col, Image, Button} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import {ListAgreementTable} from './components/ListAgreementNewTable'
import {getAllAgreements} from './core/_requests'

import useAxiosPrivate from '../../../libs/useAxiosPrivate'
import {ListAgreementResultRow} from './core/_models'
import {Link} from 'react-router-dom'
import {useAbility} from '@casl/react'
import {AbilityContext} from '../../../modules/auth/core/AbilityContext'
import ExportExcelDropdown from '../../../../ui-kit/ExportExcelDropdown/ExportExcelDropdown'

const TradeDataAgreementNewPage: FC<{subject: string}> = ({subject}) => {
  const intl = useIntl()
  const ability = useAbility(AbilityContext)
  const axiosPrivate = useAxiosPrivate()
  const [isLoadingAgreement, setIsLoadingAgreement] = useState(false)
  const [listAgreementTableData, setListAgreementTableData] =
    useState<Array<ListAgreementResultRow> | null>()
  const [pendingAgreements, setPendingAgreements] = useState<Array<ListAgreementResultRow> | null>()

  const tableRef = useRef<any>(null)

  const [countData, setCountData] = useState(0)
  const fetchListAgreement = () => {
    setIsLoadingAgreement(true)

    getAllAgreements(axiosPrivate)
      .then((res) => {
        if (res.data.count > 0) {
          setCountData(res.data.count)
          setListAgreementTableData(res.data.table_data)
        }
        if (res.data.pending_count > 0) {
          setPendingAgreements(res.data.pending_table_data)
        }
      })
      .catch((e) => {
        console.error(e)
        setIsLoadingAgreement(false)
      })
      .finally(() => {
        setIsLoadingAgreement(false)
      })
  }

  useEffect(() => {
    fetchListAgreement()
  }, [])

  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: 'Home',
            path: '/',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
          },
        ]}
      >
        {intl.formatMessage({id: subject})}
      </PageTitle>
      <>
        {pendingAgreements && pendingAgreements.length > 0 && (
          <div className='alert-no-result-data'>
            <div className='alert alert-warning d-flex align-items-center justify-content-between p-5'>
              <div className='alert-content d-flex align-items-start'>
                <span className='svg-icon svg-icon-2hx svg-icon-warning me-3'>
                  <i className='fa-solid fa-triangle-exclamation'></i>
                </span>
                <div className='d-flex flex-column'>
                  <h5 className='mb-1'>Review Needed</h5>
                  <span>There are agreements that require review or approval:</span>

                  <ul className='mt-2 mb-0'>
                    {pendingAgreements.map((agreement: any, index) => (
                      <li key={index}>
                        {ability.can('approve', 'PERM_APPROVE_AGREEMENT') ? (
                          <a
                            className='text-link'
                            href={`/new-rta/review-agreement/${agreement.id}`}
                          >
                            {agreement.name}
                          </a>
                        ) : (
                          <span className='fw-bold'>{agreement.name}</span>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        )}

        <Row className='mb-5'>
          <Col>
            <Card className='card-custom card-border'>
              <Card.Body className='d-flex justify-content-around align-items-center'>
                <Image src='/media/tina/img-result-documents.jpg' thumbnail width={110} />
                <div className='ms-5 d-flex flex-column justify-content-center'>
                  <h3 className='text-primary'>Trade Data Agreement</h3>
                  <div className='text-gray-700'>
                    Manage and explore the comprehensive list of Trade Agreements. This page allows
                    you to view existing agreements, add new entries, update details, or delete
                    obsolete records. You can also easily find specific data using filters and
                    search, and export the complete list for your records. Click the detail (
                    <span className='fa fa-eye text-primary'></span>) for more detail about the
                    agreement.
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row className='mb-5'>
          <Col>
            <Card>
              <Card.Header className='card-header-stretch'>
                <Card.Title className='w-100'>
                  <div className='title-container w-100 d-flex justify-content-between align-items-center'>
                    <div className='title d-flex align-items-center'>
                      <span className='fa fa-file-alt px-2'></span>
                      <h3 className='text-gray-700'>List Agreements</h3>
                    </div>
                    <div className='d-flex gap-2'>
                      <ExportExcelDropdown tableRef={tableRef} />
                      {ability.can('create', subject) ? (
                        <Link
                          to={'/new-rta/add'}
                          className='btn btn-primary d-flex gap-4 align-items-center'
                        >
                          <span className='fa fa-plus'></span>
                          Add
                        </Link>
                      ) : (
                        ''
                      )}
                    </div>
                  </div>
                </Card.Title>
              </Card.Header>
              <Card.Body>
                <ListAgreementTable
                  ref={tableRef}
                  rows={listAgreementTableData}
                  isLoading={isLoadingAgreement}
                  onAgreementDelete={(deletedId) => {
                    setListAgreementTableData((prev) =>
                      prev?.filter((item) => item.id !== deletedId)
                    )
                  }}
                />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </>
    </>
  )
}

export default TradeDataAgreementNewPage
